import { render, staticRenderFns } from "./kaoshiChange.vue?vue&type=template&id=7a89524e&scoped=true"
import script from "./kaoshiChange.vue?vue&type=script&lang=js"
export * from "./kaoshiChange.vue?vue&type=script&lang=js"
import style0 from "./kaoshiChange.vue?vue&type=style&index=0&id=7a89524e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a89524e",
  null
  
)

export default component.exports